module.exports = __webpack_public_path__ + "static/media/bugatti-go-drive.7b34dd0c.png";